module.exports = __webpack_public_path__ + "img/22.c9603618.jpg";